import styles from './styles.module.scss';

const DeviceInfoItem = ({ title, value }) => {
  return (
    <div className={styles.deviceInfoItem}>
      <div className={styles.deviceInfoItemCell}>{title}</div>
      <div className={styles.deviceInfoItemCell}>{value}</div>
    </div>
  );
};
export default DeviceInfoItem;
